import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";

import "./dropdown.scss";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import { DropdownLanguageItem } from "./drownDownLanguageItem.component";

type Props = {
    variant?: string;
};

const LanguageDropDownSelector = ({ variant }: Props) => {
    const { t } = useGranite();

    const currentLanguage = Config.languages.find(
        (language) => language.locale === Config.general.locale
    );

    const label = getLabel({
        language: currentLanguage,
        variant: variant,
        t: t
    });

    return (
        <Dropdown
            className="language-selector__dropdown"
            placement={"bottom"}
            isLabel={true}
        >
            <Dropdown.Toggle>
                <Dropdown.Label>{label}</Dropdown.Label>
                <Dropdown.Caret />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {Config.languages.map((language) => (
                    <DropdownLanguageItem
                        key={language["language-code"]}
                        language={language}
                        isDisabled={language.locale === Config.general.locale}
                        variant={variant}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageDropDownSelector;
